import { useContext, useEffect, useState } from "react";

// @mui material components
import {
  Button,
  FormControl,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Icon,
  Checkbox,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import SigninLayout from "../../../layout/SigninLayout";
import bgImage from "../../../assest/LoginImage.jpg";
import MaterialBox from "../../../components/MaterialBox";
import MaterialButton from "../../../components/MaterialButton";
import MaterialInput from "../../../components/MaterialInput";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MaterialTypography from "../../../components/MaterialTypography";
import colors from "../../../assest/theme/base/colors";
import { postItem } from "../../../BaseUrl";
import { LOGIN } from "../Mutation";
import MessagePopup from "../../Utils/MessagePopup";
import { UserContext } from "../../usercontext/usercontext";
import { AccessRoute } from "../../Utils/AccessRoute";
import routes from "../../../routes";

function Signin() {
  const navigate = useNavigate();
  const { setUser, setisuser } = useContext(UserContext);
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success", // 'success' or 'error'
  });

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [signInData, setSignInData] = useState({
    email: "",
    password: null,
    rememberMe: false,
    emailStatus: "unchecked",
    passwordStatus: "unchecked",
  });

  const [stage] = useState("sign-in");

  const [viewPassword, setViewPassword] = useState(false);

  useEffect(() => {
    setPageState({
      ...pageState,
      state: "default",
    });
  }, []);

  const handlePasswordVisibility = () => {
    setViewPassword(!viewPassword);
  };

  /**
   * Handles the change event for form inputs.
   * @param {Object} event - The event object generated by the change event.
   * @returns {void}
   */
  const handleChange = (event) => {
    const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,6}$/g);
    //lowercase regex expression
    const lowerCaseRegex = new RegExp("^(?=.*[a-z])");
    //uppercase regex expression
    const upperCaseRegex = new RegExp("^(?=.*[A-Z])");
    //number regex expression
    const numberRegex = new RegExp("^(?=.*[0-9])");
    //special character regex expression
    const specialCharacterRegex = new RegExp("^(?=.*[@$!%*?&])");
    //length regex expression
    const lengthRegex = new RegExp("([a-zA-Z0-9@$!%*?&]{3,16})$");

    let signInState = { ...signInData };
    if (event.target.name === "email") {
      if (emailRegex.test(event.target.value) === true) {
        signInState.emailStatus = "success";
      } else {
        signInState.emailStatus = "error";
      }
      signInState[event.target.name] = event.target.value;
    } else if (event.target.name === "password") {
      if (
        // lowerCaseRegex.test(event.target.value) &&
        // upperCaseRegex.test(event.target.value) &&
        // numberRegex.test(event.target.value) &&
        // specialCharacterRegex.test(event.target.value) &&
        lengthRegex.test(event.target.value) === true
      ) {
        signInState.passwordStatus = "success";
      } else {
        signInState.passwordStatus = "error";
      }
      signInState[event.target.name] = event.target.value;
    }
    setSignInData(signInState);
  };

  const handleSignIn = async () => {
    const { email, password } = signInData;

    setPageState({ ...pageState, loading: true });

    const variables = {
      username: email,
      password: password,
    };

    try {
      const response = await postItem(LOGIN, { input: variables });
      if (response?.login?.success === true) {
        let userdata = response?.login?.role;
        let token = response?.login?.token;
        let refreshToken = response?.login?.refreshToken;
        let isuser = {
          userid: response?.login?.userId,
          username: response?.login?.username,
        };
        setPopup({
          open: true,
          message: "Login Successfully",
          severity: "success",
        });
        sessionStorage.setItem("user", JSON.stringify(userdata));
        sessionStorage.setItem("userid", JSON.stringify(isuser));
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("refreshToken", refreshToken);

        setUser(userdata);
        setisuser(isuser);

        const firstRoute = AccessRoute(routes, userdata?.permission); //actual role permission

        // const firstRoute = AccessRoute(routes, accessData);//test default use role permission

        if (firstRoute && firstRoute.route) {
          setTimeout(() => {
            navigate(firstRoute.route);
          }, 1000);
          // Navigate to the first accessible route
        } else {
          console.error("No accessible route found.");
          setTimeout(() => {
            navigate("/dashboard");
          }, 1000);
        }
      } else {
        setPopup({
          open: true,
          message: response?.login?.message,
          severity: "error",
        });
      }
    } catch (error) {
      console.error(error);
      setPopup({
        open: true,
        message: error,
        severity: "error",
      });
      setPageState({
        ...pageState,

        loading: false,

        error: true,

        message: "An error occurred. Please try again.",
      });
    } finally {
    }
  };

  return (
    <SigninLayout
      // title="KEELS"
      description="Log In"
      illustration={bgImage}
    >
      
    
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      {pageState.error === true && (
        <Dialog maxWidth="sm" open={pageState.error} fullWidth>
          <DialogTitle>
            <Typography variant="body1">{pageState.title}</Typography>
          </DialogTitle>
          <DialogContent variant="body2">{pageState.message}</DialogContent>
          <DialogActions>
            <Button
              color="error"
              variant="text"
              onClick={() =>
                setPageState({
                  ...pageState,
                  loading: false,
                  error: false,
                  title: "",
                  message: "",
                  state: "default",
                })
              }
            >
              close
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {pageState.state === "default" && (
        <MaterialBox component="form" role="form">
          {stage === "sign-in" && (
            <>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 12 }}>
                  <FormControl fullWidth>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      sx={{ color: "black" }}
                    >
                      Email:
                    </MaterialTypography>
                    <MaterialInput
                      fullWidth
                      placeholder="Email"
                      name="email"
                      variant="standard"
                      value={signInData.email}
                      onChange={handleChange}
                      error={signInData.emailStatus === "error" ? true : false}
                      success={
                        signInData.emailStatus === "success" ? true : false
                      }
                    />
                    {/* {signInData.emailStatus === "error" ? (
                      <FormControl error>
                        <FormHelperText>
                          Please enter valid email address
                        </FormHelperText>
                      </FormControl>
                    ) : null} */}
                  </FormControl>
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }}>
                  <FormControl fullWidth>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      sx={{ color: "black" }}
                    >
                      Password:
                    </MaterialTypography>
                    <MaterialInput
                      fullWidth
                      placeholder="Password"
                      name="password"
                      type={viewPassword ? "text" : "password"}
                      variant="standard"
                      value={signInData.password}
                      onChange={handleChange}
                      error={
                        signInData.passwordStatus === "error" ? true : false
                      }
                      success={
                        signInData.passwordStatus === "success" ? true : false
                      }
                      icon={
                        viewPassword
                          ? {
                              direction: "right",
                              component: (
                                <Icon color="action" fontSize="small">
                                  <VisibilityOffIcon
                                    onClick={handlePasswordVisibility}
                                    style={{ cursor: "pointer" }}
                                  />
                                </Icon>
                              ),
                            }
                          : {
                              direction: "right",
                              component: (
                                <Icon color="action" fontSize="small">
                                  <VisibilityIcon
                                    onClick={handlePasswordVisibility}
                                    style={{ cursor: "pointer" }}
                                  />
                                </Icon>
                              ),
                            }
                      }
                    />
                    {/* {signInData.passwordStatus === "error" ? (
                      <FormControl error>
                        <FormHelperText>
                          Your password must be minimum 8 characters long with
                          lower case, upper case, number and special character.
                        </FormHelperText>
                      </FormControl>
                    ) : null} */}
                  </FormControl>
                </Grid>
              </Grid>

              <MaterialBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                my={2}
              >
                {/* Remember Me Section */}
                <MaterialBox display="flex" alignItems="center" gap="8px">
                  <Checkbox
                    checked={signInData.rememberMe}
                    onChange={(e) => {
                      setSignInData((prev) => ({
                        ...prev,
                        rememberMe: e.target.checked,
                      }));
                    }}
                    sx={{
                      color: "#1A1A1A",
                      "&.Mui-checked": {
                        color: "#C40001", // Optional: Customize checked color
                      },
                    }}
                  />
                  <MaterialTypography
                    variant="body2"
                    sx={{ color: "#1A1A1A", fontSize: "14px" }}
                  >
                    Remember Me
                  </MaterialTypography>
                </MaterialBox>

                {/* Forgot Password Section */}
                <MaterialBox>
                  <MaterialButton
                    variant="text"
                    onClick={() => {
                      navigate("/forget-password");
                    }}
                    sx={{
                      padding: 0,
                      textTransform: "capitalize",
                      color: "#1A1A1A",
                      "&:hover": {
                        color: "#1A1A1A", // Reverse gradient on hover
                      },
                    }}
                    disabled={signInData.emailStatus !== "success"}
                  >
                    Forgot Password?
                  </MaterialButton>
                </MaterialBox>
              </MaterialBox>

              <MaterialBox
                sx={{ display: "flex", justifyContent: "center" }}
                my={2}
              >
                <MaterialButton
                  variant="contained"
                  onClick={() => {
                    handleSignIn();
                  }}
                  disabled={
                    signInData.emailStatus === "success" &&
                    signInData.passwordStatus === "success"
                      ? false
                      : true
                  }
                  sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                    "&:hover": {
                      background: colors.loginHover, // Reverse gradient on hover
                    },
                  }}
                >
                  Log In
                </MaterialButton>
              </MaterialBox>

             
            </>
          )}
          {stage === "forget-password" && (
            <>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 12 }}>
                  <MaterialInput
                    fullWidth
                    placeholder="Email"
                    name="email"
                    variant="outlined"
                    value={signInData.email}
                    onChange={handleChange}
                    error={signInData.emailStatus === "error" ? true : false}
                    success={
                      signInData.emailStatus === "success" ? true : false
                    }
                  />
                </Grid>
              </Grid>
              <MaterialBox my={2}>
                <MaterialButton
                  variant="contained"
                  color="dark"
                  fullWidth
                  onClick={() => {
                    handleSignIn();
                  }}
                  disabled={
                    signInData.emailStatus === "success" &&
                    signInData.passwordStatus === "success"
                      ? false
                      : true
                  }
                >
                  Login in
                </MaterialButton>
              </MaterialBox>
            </>
          )}
        </MaterialBox>
      )}
      </SigninLayout>
  
   
  );
}

export default Signin;
